import { Flex, Pane, Text } from '@leverege/ui-elements'
import React from 'react'
import S from '../Alerts.css'

export default function ActiveAlerts( props ) {
  const { label, icon, result } = props
  const { counts : { perCause } } = result

  return (
    <Pane className={S.head} variant="card">
      <Text variant="captionBold" icon={icon}>{label}</Text>
      <Flex justify="spaceBetween" layout="flex:rowSpaceBetween">
        <Flex variant="colM" style={{ flexGrow : 1 }}>
          <Text variant="caption">Inventory Hole</Text>
          <Text variant="title">{perCause?.inventoryHole ?? 0}</Text>
        </Flex>
        <Flex variant="colM" style={{ flexGrow : 1 }}>
          <Text variant="caption">Misplaced Product</Text>
          <Text variant="title">{perCause?.misplacedProduct ?? 0}</Text>
        </Flex>
        <Flex variant="colM" style={{ flexGrow : 1 }}>
          <Text variant="caption">Unsupervised Dog</Text>
          <Text variant="title">{perCause?.unsupervisedDog ?? 0}</Text>
        </Flex>
        <Flex variant="colM" style={{ flexGrow : 1 }}>
          <Text variant="caption">Person Fell</Text>
          <Text variant="title">{perCause?.personFell ?? 0}</Text>
        </Flex>
      </Flex>
    </Pane>
  )
}
